import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function downloadDevisLogoCourtierRequest(isLoading) {
  return {
    type: actionsTypesMembers.DOWNLOAD_LOGO_COURTIER_REQUEST,
    isLoading,
  }
}
function downloadDevisLogoCourtierFailure(isError) {
  return {
    type: actionsTypesMembers.DOWNLOAD_LOGO_COURTIER_FAILURE,
    isError,
  }
}
function downloadDevisLogoCourtierSuccess(isSuccess, logoCourtier) {
  return {
    type: actionsTypesMembers.DOWNLOAD_LOGO_COURTIER_SUCCESS,
    isSuccess,
    logoCourtier,
  }
}
export function fetchDownloadDevisLogoCourtierAction(userCode) {
  return function(dispatch, getState) {

    dispatch(downloadDevisLogoCourtierRequest(true))

    return backendMembers.getCourtier(userCode)
      .then(logoCourtier => {
        dispatch(downloadDevisLogoCourtierRequest(false))
        dispatch(downloadDevisLogoCourtierSuccess(true, logoCourtier))
      })
      .catch(error => {
        dispatch(downloadDevisLogoCourtierRequest(false))
        dispatch(downloadDevisLogoCourtierFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Simulation/Devis.js